import React from 'react';
import ActionButton from '../Common/ActionButton';
import InputSelectField from '../Fields/InputSelectField';
import useUpdateRate from '../../Hooks/updateRate';
import useSuspendFromAccessSystem from '../../Hooks/suspendFromAccessSystem';
import useReactivateAccessSystem from '../../Hooks/reactivateAccessSystem';

import './ParkerActionsPanel.scss';
import { useSetParkerToNeutral } from '../../Hooks/useSetParkerToNeutral';

const errorStyles = {
  color: 'red',
  fontWeight: 'bold'
}

function ParkerActionsPanel({ parker, rates, parkerActionCallback }) {
  const parker_id = parker.fields.id.value;
  const subscription_id = parker.fields.subscription_id.value;

  const {
    currentRate,
    setCurrentRate,
    inProgress: updateRateInProgress,
    errorMessage: updateRateError,
    updateRate
  } = useUpdateRate(subscription_id, parker, parkerActionCallback)

  const {
    inProgress: suspendAccessInProgress,
    errorMessage: suspendError,
    suspendFromAccessSystem
  } = useSuspendFromAccessSystem(parker_id, parkerActionCallback);

  const {
    inProgress: reactivateInProgress,
    errorMessage: reactivateError,
    reactivateAccessSystem
  } = useReactivateAccessSystem(parker_id, parkerActionCallback);

  const {
    inProgress: setNeutralInProgress,
    errorMessage: setNeutralError,
    setParkerToNeutral
  } = useSetParkerToNeutral(parker_id);

  const renderRateChangeForm = () => {
    return (
      <div className="parkchirp-parker-actions--row">
        <InputSelectField
          inputId="parkchirp-parker-actions--update-rate"
          value={currentRate}
          options={rates}
          editMode={true}
          onChange={value => setCurrentRate(value)}
         /> 

        <ActionButton label="Update Rate"
          classNames={['parkchirp-parker-actions--update-rate-action']}
          onClick={updateRate}
          inProgressState={updateRateInProgress}
        />
      </div>
    )
  }

  const renderSuspendAccessSystemForm = () => {
    return (
      <div className="parkchirp-parker-actions--row">
        <ActionButton label="Block Access to Facility"
          onClick={suspendFromAccessSystem}
          inProgressState={suspendAccessInProgress}
        />
      </div>
    );
  }

  const renderReactivateAccessSystemForm = () => {
    return (
      <div className="parkchirp-parker-actions--row">
        <ActionButton label="Reactivate Access System"
          onClick={reactivateAccessSystem}
          inProgressState={reactivateInProgress}
        />
      </div>
    );
  }

  const renderSetParkerToNeutralForm = () => {
    return (
      <div className="parkchirp-parker-actions--row">
        <ActionButton label="Set Parker To Neutral"
          onClick={setParkerToNeutral}
          inProgressState={setNeutralInProgress}
        />
      </div>
    );
  }

  const parker_suspension_status = parker.fields.suspension_status.value;
  const parker_termination_status = parker.fields.termination_status.value;
  const parker_access_system_status = parker.fields.access_system_status.value;

  const isActive = ['ACTIVE', 'TERMINATION_PENDING'].includes(parker_termination_status);

  const should_render_rate_change =  parker_suspension_status === 'ACTIVE' || parker_termination_status === 'ACTIVE';
  const should_render_suspend_action = parker_access_system_status === 'ON' && isActive;
  const should_render_reactivate_action = parker_access_system_status !== 'ON' && isActive;
  
  return (
    <>
      {suspendError && <p style={errorStyles}>{suspendError}</p>}
      {updateRateError && <p style={errorStyles}>{updateRateError}</p>}
      {reactivateError && <p style={errorStyles}>{reactivateError}</p>}
      {should_render_rate_change && renderRateChangeForm()}
      {should_render_suspend_action && renderSuspendAccessSystemForm()}
      {should_render_reactivate_action && renderReactivateAccessSystemForm()}
      {isActive && renderSetParkerToNeutralForm()}
      {setNeutralError && <p style={errorStyles}>{setNeutralError}</p>}
    </>
  );
}

export default React.memo(ParkerActionsPanel);